import { de } from "date-fns/locale/de";
import { enUS } from "date-fns/locale/en-US";
import { useTranslation } from "react-i18next";

export const useI18NextLocale = () => {
  const { i18n } = useTranslation();
  const dateLocale = i18n.language === "de" ? de : enUS;
  return dateLocale;
};
